import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components'
import { Headline1, LargeFontParagraph, Overline3 } from './../../Components/Common';
import withRouter from './../../Utilities/withRouter'
//import { ReactComponent as BackgroundImage } from './../../Resources/img_footer-banner-v2.svg';
import ThankyouDevice1 from './../../Resources/ThankyouDevice1.png';
import ThankyouDevice2 from './../../Resources/ThankyouDevice2.png';
import _BackgroundImage from './../../Resources/img_footer-banner-v2.svg';

const BackgroundImage = styled.img.attrs({src:_BackgroundImage})`
    width: 2530px;
    height: 299px;
    object-fit: contain;
    object-position: left calc(100% + 10px); 
`;
const Column1 = styled.div`
    display: flex;
    flex-direction: column;
    width: 48%;
    box-sizing: border-box;         /* Opera/IE 8+ */
    -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
    -moz-box-sizing: border-box;    /* Firefox, other Gecko */
`;

const Column2 = styled.div`
    display: flex;
    flex-direction: column;
    width: 48%;
    box-sizing: border-box;         /* Opera/IE 8+ */
    -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
    -moz-box-sizing: border-box;    /* Firefox, other Gecko */
`;

const CircleContainer = styled.div`
    width: 712.058px;
    height: 712.058px;
    flex-shrink: 0;
    position: relative;
`;

const Circle = styled.div`
    position: absolute;
    width: 712.058px;
    height: 712.058px;
    border-radius: 712.058px;
    background: #B9DEFF;
    box-shadow: 0px 3.946px 3.946px 0px rgba(0, 0, 0, 0.25);
`;
const DeviceContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 712.058px;
    height: 712.058px;
    align-items: center;
    justify-content: center;
    gap: 24px;
    position: absolute;
    &>img {
        flex-grow: 0;
        flex-shrink: 0;
    }
`;

const Reminder = styled.div`
    width: 100vw;
    background-color: #000;
`;

const Bottom = styled.div`
    position: absolute;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    top: 662px;
    left: 0px;
    height: calc(100vh - 662px);
    align-items: flex-start;
    justify-content: flex-start;
    @media (min-width: 310px) and (max-width: 767px) {
        top: 400px;
         height: calc(100vh - 400px);
    }
    @media (min-width: 768px) and (max-width: 1360px) {
        top: 500px;
        height: calc(100vh - 500px);
    }
    ${BackgroundImage}{
        width: 100vw;
        flex: 1;
    }
    ${Reminder}{
        flex: 1;
    }
   
`;

const FirstImage = styled.img``;
const SecondImage = styled.img`
    margin-top: 24px;
`;
const Centered = styled.div`
    flex-grow: 1;
    gap: 10px;
    display: flex;
    flex-direction: row;
    max-width: 1440px;
    height: 100vh;
    flex-wrap: wrap;
    margin: 80px auto auto auto;
    padding-left: 60px;
    box-sizing: border-box;         /* Opera/IE 8+ */
    -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
    -moz-box-sizing: border-box;    /* Firefox, other Gecko */
    @media (min-width: 319px) and (max-width: 767px){
        max-width: 100vw;
        overflow: hidden;
        padding-left: 20px;
        padding-right: 20px;
        padding-top: 50px;
        margin: 0px auto auto auto;
        ${Column1} {
            width: 100vw;
            flex-basis: 100%;
            height: 100%;
            overflow-x: hidden;
            overflow-y: auto;
            padding-bottom: 15px;
            ::-webkit-scrollbar {
            width: 0px;
            background: transparent; /* make scrollbar transparent */
        }
        }
        ${Overline3}{
            font-size: 30px;
        }
        ${Headline1}{
            font-size: 40px;
            line-height: 50px;
        }
        ${LargeFontParagraph} {
            font-size: 18px;
            line-height: 30px;
        }
    }
    @media (min-width: 768px) and (max-width: 1360px){
        padding:0px 10px 0 24px;
        margin: 50px auto auto auto;
        max-width: 100vw;
        justify-content: center;
        flex-wrap: nowrap;
        height: auto;
        ${Column1} {
            width: calc(50% - 24px);
            z-index: 1;
        }
        ${Column2} {
            width: auto;
            margin-right: 10px;
            margin-left: auto;
        }
        ${LargeFontParagraph} {
            font-size: 18px;
            line-height: 30px;

        }
        ${Headline1} {
            font-size: 40px;
            line-height: 50px;
        }
        ${CircleContainer}{
            min-width: 368px;
            min-height: 368px;
            width: auto;
            height: auto;
        }
        ${Circle}{
            min-width: 368px;
            min-height: 368px;
            width: auto;
            height: auto;
            border-radius: 50% 50%;
        }
        ${DeviceContainer}{
            min-width: 368px;
            min-height: 368px;
            width: auto;
            height: auto;
        }
        ${FirstImage}{
            width: 136px;
        }
        ${SecondImage}{
            width: 136px;
        }
       
    }
    @media (min-width: 768px) and (max-width: 1024px){
        ${Overline3}{
            font-size: 26px;
            line-height: normal;
        }
        ${LargeFontParagraph} {
            font-size: 15px;
            line-height: 27px;

        }
        ${Headline1} {
            font-size: 35px;
            line-height: 43px;
        }
    
    }
    @media (min-width: 1100px) and (max-width: 1360px){
        padding:0px 40px 0 40px;
        ${CircleContainer}{
            min-width: 500px;
            min-height: 500px;
            width: auto;
            height: auto;
        }
        ${Circle}{
            min-width: 500px;
            min-height: 500px;
            width: auto;
            height: auto;
            border-radius: 50% 50%;
        }
        ${DeviceContainer}{
            min-width: 500px;
            min-height: 500px;
            width: auto;
            height: auto;
        }
        ${FirstImage}{
            width: 200px;
        }
        ${SecondImage}{
            width: 200px;
        }
    }
`;
class Thankyou extends Component {
    componentDidMount(){
        window.gtag('event', 'screen_view', {
            'app_name': 'App Creator',
            'screen_name': 'Thank You'
        });
    }
    render() {
        return (
            <Centered>
                <Column1>
                    <Headline1><Overline3>Submitted</Overline3><br />Thank you!</Headline1>
                    <LargeFontParagraph style={{marginTop: '30px'}}>We have received your request. One of our customer success managers will be in touch soon to discuss next steps.</LargeFontParagraph>
                </Column1>
                <Column2>
                    <Circle />
                    <Bottom>
                        <BackgroundImage />
                        <Reminder />
                    </Bottom>
                    <CircleContainer>
                        <DeviceContainer>
                            <FirstImage src={ThankyouDevice1} />
                            <SecondImage src={ThankyouDevice2} />
                        </DeviceContainer>
                    </CircleContainer>
                </Column2>
            </Centered>
);

    }
}

export default withRouter(Thankyou);